var elementName = 'swiper-slider-container';
if (!customElements.get(elementName)) {
  class swiperSliderContainer extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('.swiper-thumb').forEach((item) => {
        item.addEventListener("click", this.clickHandler.bind(this));
      });
      if(this.isTouchDevice()===false) {
        this.querySelectorAll('.swiper-thumb__container--horizontal').forEach((item) => {
          var _this = this;
          item.addEventListener("mouseenter", function(){
            if(window.innerWidth <= 1024) return false;
            if(item.scrollWidth <= _this.offsetWidth) return false;
            document.body.style.paddingRight = window.innerWidth > 1024 ? _this.getScrollbarWidth() + 'px' : '';
            document.body.classList.add('overflow-hidden');
          });
          item.addEventListener("mouseleave", function(){
            if(window.innerWidth <= 1024) return false;
            if(item.scrollWidth <= _this.offsetWidth) return false;
            document.body.classList.remove('overflow-hidden');
            document.body.style.paddingRight = '';
          });
        });
      }
      
      this.swiperthumbcontainer = this.querySelector('.swiper-thumb__container');
      this.swiper = this.querySelector('.swiper');
      this.duration = 100;
      this.swiper.addEventListener('slide_inited', this.slideInitedCustom.bind(this), false);
      this.swiper.addEventListener('slide_changed_custom', this.slideChangedCustom.bind(this), false);

      this.closest('.product--thumbnail_slider__mobile') && this.mobileThumbSize();
    }
    isTouchDevice(){
      return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
    }
    mobileThumbSize(){
      var swiper__thumb__container = this.querySelector('.swiper-thumb__container');
      if(window.innerWidth > 576 || !swiper__thumb__container) return false;
      window.addEventListener("resize", this.resizeHandler.bind(this), false);
      this.resizeHandler();
    }
    resizeHandler(){
      var swiper__thumb__container = this.querySelector('.swiper-thumb__container'),
          w = swiper__thumb__container.offsetWidth,
          item_w = (swiper__thumb__container.offsetWidth - 10 * 4)/5;
      swiper__thumb__container.style.setProperty('--thumb-width', `${item_w}px`);
    }
    slideInitedCustom(){
      var sect = this.closest('.shopify-section')||this.closest('.popup-modal__content__data');
      if(sect.querySelector('select-option-js.active')){
        return false;
      }
      var default_media_id = this.getAttribute('data-current-media-id');
      this.changeSlideSwiper(default_media_id, 0);
    }
    slideChangedCustom(){
      if(!this.querySelector('.swiper-slide-active [data-media-id]')) return false;
      var _this = this;
      if(this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024){
        setTimeout(function(){
          var _id = _this.querySelector('.swiper-slide-active [data-media-id]').getAttribute('data-media-id');
          _this.horizontaldesign(_id);
        },0);
      }
      else{
        setTimeout(function(){
          var _id = _this.querySelector('.swiper-slide-active [data-media-id]').getAttribute('data-media-id');
          _this.verticaldesign(_id);
        },0);
      }
      setTimeout(function(){
        _this.playActiveMedia(_this.querySelector('.swiper-slide-active [data-media-id]'));
      },100);
    }
    clickHandler(e){
      this.querySelector('.active').classList.remove('active');
      e.currentTarget.classList.add('active');

      var _id = e.currentTarget.getAttribute('data-media-id');
      this.changeSlideSwiper(_id);
    }
    changeSlideSwiper(_id, delay){
      delay = delay === undefined || delay === null ? 300 : delay;
      var swiperslider = this.querySelector('swiper-slider');

      if(!swiperslider.querySelector(`[data-media-id="${_id}"]`)) return;
      var item_img = swiperslider.querySelector(`[data-media-id="${_id}"]`).closest('.swiper-slide');
      if(!item_img) return;
      const nodes = Array.prototype.slice.call( item_img.parentNode.childNodes );
      var index = nodes.indexOf(item_img);

      var sw = swiperslider.querySelectorAll(`.swiper-slide`)[0];
      const sw_nodes = Array.prototype.slice.call( sw.parentNode.childNodes );
      const sw_index = nodes.indexOf(sw);
      index = index - sw_index;

      this.querySelector('.swiper').selectSlide(index, delay);
      this.playActiveMedia(item_img);
    }
    changeSlide(_id){
      if(this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024){
        this.horizontaldesign(_id);
      }
      else{
        this.verticaldesign(_id);
      }
      this.changeSlideSwiper(_id);
    }
    verticaldesign(...args){
      if(!this.swiperthumbcontainer) return false;
      var _id = args[0],
          item = this.swiperthumbcontainer.querySelector(`[data-media-id="${_id}"]`),
          temp = 0;
      this.swiperthumbcontainer.querySelector('.active').classList.remove('active');
      item.classList.add('active');

      var _y = item.offsetTop-this.swiperthumbcontainer.offsetTop,
          _h = this.swiperthumbcontainer.offsetHeight,
          main_scrolltop = this.swiperthumbcontainer.scrollTop,
          item_y = _y-main_scrolltop+item.offsetHeight;

      if(item_y > _h){
        temp = main_scrolltop + (item_y-_h);
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollTop');
      }
      else if(_y < main_scrolltop){
        temp = this.swiperthumbcontainer.scrollTop - (main_scrolltop - _y);
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollTop');
      }
    }
    horizontaldesign(...args){
      if(!this.swiperthumbcontainer) return false;
      var _id = args[0],
          item = this.swiperthumbcontainer.querySelector(`[data-media-id="${_id}"]`),
          temp = 0;
      this.swiperthumbcontainer.querySelector('.active').classList.remove('active');
      item.classList.add('active');
    
      var _x = item.offsetLeft-this.swiperthumbcontainer.offsetLeft,
          _w = this.swiperthumbcontainer.offsetWidth,
          main_scrollleft = this.swiperthumbcontainer.scrollLeft,
          item_x = _x-main_scrollleft+item.offsetWidth;

      var delta = window.innerWidth <= 576 ? 15 : 0;
      if(item_x > _w){
        temp = main_scrollleft + (item_x-_w) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollLeft');
      }
      else if(_x < main_scrollleft){
        temp = this.swiperthumbcontainer.scrollLeft - (main_scrollleft - _x) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollLeft');
      }
    }
    playActiveMedia(activeItem) {
      const deferredMedia = activeItem.parentNode.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }
    scrollTo(el, to, duration, option) {
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      const element = el;
      const start = element[option],
            change = to - start,
            increment = 20;
      var currentTime = 0;
      
      const animateScroll = function(){
        currentTime += increment;
        const val = Math.easeInOutQuad(currentTime, start, change, duration);
        element[option] = val;
        if(currentTime < duration) {
          window.setTimeout(animateScroll, increment);
        }
      };
      animateScroll();
    }
    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }
  customElements.define('swiper-slider-container', swiperSliderContainer);
}

elementName = 'theme-lightbox';
if (!customElements.get(elementName)) {
  // AG zoom fix: preserve the theme's slider and public open(mediaId) interface.
  class themeLightbox extends HTMLElement {
    constructor() {
      super();
      this._open = false;
      this._pendingIndex = null;
      this._onResize = this.resizeHandler.bind(this);
      this._onClick = (event) => {
        if (event.target.closest('.theme-lightbox__toggle')) this.close();
      };
      this._onKey = this.keyHandler.bind(this);
      this._onInit = () => this.selectPendingSlide();
      this._onFocus = (event) => {
        if (this._open && !this.contains(event.target)) this.focusClose();
      };
    }
    connectedCallback() {
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKey);
      this.addEventListener('load', this._onResize, true);
      window.addEventListener('resize', this._onResize);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', this._onResize);
      this.bindSlider();
    }
    disconnectedCallback() {
      if (this._open) this.close();
      clearTimeout(this._closeTimer);
      clearTimeout(this._slideTimer);
      cancelAnimationFrame(this._frame);
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKey);
      this.removeEventListener('load', this._onResize, true);
      window.removeEventListener('resize', this._onResize);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', this._onResize);
      if (this._slider) this._slider.removeEventListener('slide_inited', this._onInit);
    }
    bindSlider() {
      const slider = this.querySelector('swiper-slider.swiper');
      if (slider === this._slider) return;
      if (this._slider) this._slider.removeEventListener('slide_inited', this._onInit);
      this._slider = slider;
      if (slider) slider.addEventListener('slide_inited', this._onInit);
    }
    resizeHandler() {
      // Product photos are constrained in both dimensions by scoped CSS,
      // including when the image has not loaded yet. Keep other galleries working.
      if (!this.classList.contains('ag-product-lightbox')) {
        const area = this.querySelector('.theme-lightbox__content');
        if (area && area.clientHeight && area.clientWidth) {
          this.querySelectorAll('.theme-lightbox__image').forEach((image) => {
            if (!image.naturalWidth || !image.naturalHeight) return;
            image.classList.toggle('theme-lightbox__image--wide',
              image.naturalWidth / image.naturalHeight >= area.clientWidth / area.clientHeight);
          });
        }
      }
      const swiper = this._slider && this._slider.swiper;
      if (this._open && swiper && !swiper.destroyed && typeof swiper.update === 'function') swiper.update();
    }
    open(mediaId) {
      const media = Array.from(this.querySelectorAll('[data-media-id]'))
        .find((item) => item.getAttribute('data-media-id') === String(mediaId));
      const slide = media && media.closest('.swiper-slide');
      if (!slide) return;
      // Only element slides count. Whitespace/comments must never change the index.
      const slides = Array.from(slide.parentElement.children).filter((item) => item.classList.contains('swiper-slide'));
      const index = slides.indexOf(slide);
      if (index < 0) return;
      clearTimeout(this._closeTimer);
      clearTimeout(this._slideTimer);
      cancelAnimationFrame(this._frame);
      if (!this._open) {
        this._returnFocus = document.activeElement;
        if (!this._returnFocus || this._returnFocus === document.body) {
          this._returnFocus = Array.from(document.querySelectorAll('lightbox-opener, zoom-icon'))
            .find((item) => item.getAttribute('data-id') === this.id && item.getAttribute('data-media-id') === String(mediaId));
        }
        this._bodyState = {
          padding: document.body.style.paddingRight,
          overflow: document.body.style.overflow,
          locked: document.body.classList.contains('overflow-hidden')
        };
        const gap = this.getScrollbarWidth();
        if (gap > 0) document.body.style.paddingRight = ((parseFloat(getComputedStyle(document.body).paddingRight) || 0) + gap) + 'px';
        document.body.style.overflow = 'hidden';
        document.body.classList.add('overflow-hidden');
        document.addEventListener('focusin', this._onFocus);
      }
      this._open = true;
      this._pendingIndex = index;
      this.classList.add('active');
      this.removeAttribute('aria-hidden');
      this.bindSlider();
      this._frame = requestAnimationFrame(() => {
        if (!this._open) return;
        this.classList.add('animate');
        this.resizeHandler();
        this.selectPendingSlide();
        this.focusClose();
      });
    }
    selectPendingSlide(attempt = 0) {
      clearTimeout(this._slideTimer);
      if (!this._open || this._pendingIndex === null) return;
      this.bindSlider();
      const swiper = this._slider && this._slider.swiper;
      if (swiper && !swiper.destroyed && typeof swiper.slideTo === 'function') {
        if (typeof swiper.update === 'function') swiper.update();
        swiper.slideTo(this._pendingIndex, 0);
        this._pendingIndex = null;
      } else if (attempt < 100) {
        // Swiper is lazy loaded by the theme when the previously hidden box opens.
        this._slideTimer = setTimeout(() => this.selectPendingSlide(attempt + 1), 100);
      }
    }
    focusClose() {
      const target = this.querySelector('.theme-lightbox__toggle') || this.querySelector('[role="dialog"]');
      if (target) target.focus({ preventScroll: true });
    }
    keyHandler(event) {
      if (!this._open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        this.close();
        return;
      }
      const input = event.target.closest('input, textarea, select, [contenteditable="true"], model-viewer');
      if (!input && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
        const selector = event.key === 'ArrowLeft' ? '.custom-swiper-button-prev' : '.custom-swiper-button-next';
        const control = this.querySelector(selector);
        if (control) { event.preventDefault(); event.stopPropagation(); control.click(); }
      }
      if (event.key !== 'Tab') return;
      const controls = Array.from(this.querySelectorAll('button:not([disabled]), a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
        .filter((item) => item.getClientRects().length && getComputedStyle(item).visibility !== 'hidden' && item.getAttribute('aria-hidden') !== 'true')
        .filter((item) => !item.closest('.swiper-slide') || item.closest('.swiper-slide-active'));
      if (!controls.length) { event.preventDefault(); this.focusClose(); return; }
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    }
    close() {
      if (!this._open) return;
      this._open = false;
      this._pendingIndex = null;
      clearTimeout(this._slideTimer);
      cancelAnimationFrame(this._frame);
      this.classList.remove('animate');
      document.removeEventListener('focusin', this._onFocus);
      if (this._bodyState) {
        document.body.style.paddingRight = this._bodyState.padding;
        document.body.style.overflow = this._bodyState.overflow;
        document.body.classList.toggle('overflow-hidden', this._bodyState.locked);
      }
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      const target = this._returnFocus;
      if (target && target.isConnected && typeof target.focus === 'function') {
        const temporaryTabindex = !target.matches('button, a[href], input, select, textarea, [tabindex]');
        if (temporaryTabindex) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (temporaryTabindex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      }
      this._closeTimer = setTimeout(() => {
        if (!this._open) { this.classList.remove('active'); this.setAttribute('aria-hidden', 'true'); }
      }, 180);
    }
    getScrollbarWidth() {
      return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    }
  }
  customElements.define('theme-lightbox', themeLightbox);
}

elementName = 'lightbox-opener';
if (!customElements.get(elementName)) {
  class lightboxOpener extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.clickHandler.bind(this));
    }
    clickHandler(e){
      var id = this.getAttribute('data-id'),
          item = document.getElementById(id),
          data_media_id = this.getAttribute('data-media-id');
      item.open(data_media_id);
    }
  }
  customElements.define('lightbox-opener', lightboxOpener);
}